import Utility from 'Core/Utility';
import { SecuredAPMProxyClient } from 'Core/Api/APMProxy/SecuredAPMProxyClient';
import { SwaggerException, BolChargesResponseDto } from 'Core/Api/APMProxy/Api';
import CargoChargesSearchModel from '../CargoChargesSearchBar/CCSearchBarModel';
// import CargoChargesResultModel, { CargesModel } from "../CargoChargesResults/CargoChargesResultsModel";
import CargoChargesResultModel from '../CargoChargesResults/CargoChargesResultsModel';
import moment from 'moment';

export class CargoChargesHandler {
  props: any;
  constructor(props) {
    this.props = props;
  }

  GetBillOfLadingCharges(cargoSeach: CargoChargesSearchModel): Promise<CargoChargesResultModel> {
    let client = new SecuredAPMProxyClient();
    client.showLoading = true;

    var results: CargoChargesResultModel;
    const storagetoDate = cargoSeach.storageToDate.format('YYYYMMDD');
    return client.getBillOfLadingCharges(cargoSeach.bolNumber, storagetoDate).then(x => {
      if (x.errors !== undefined && x.errors.length) {
        throw Error(x.errors[0]);
      }

      if (x.bolReferenceNos !== undefined && x.data !== undefined) {
        results = {
          bolNumber: cargoSeach.bolNumber,
          refNumber: x.bolReferenceNos[0],
          storageDueDate: moment.parseZone(cargoSeach.storageToDate),
          charges: x.data,
          total: Number.parseFloat(x.data.reduce((p, c) => p + c.chargeAmount!, 0).toFixed(2)),
        };
      }
      return results;
    });
  }

  GetRawBillOfLadingCharges(cargoSeach: CargoChargesSearchModel): Promise<BolChargesResponseDto> {
    let client = new SecuredAPMProxyClient();
    client.showLoading = true;

    var results: CargoChargesResultModel;
    const storagetoDate = cargoSeach.storageToDate.format('YYYYMMDD');
    return client.getBillOfLadingCharges(cargoSeach.bolNumber, storagetoDate);
  }
}
